export interface DialogParams {
  title: string;
  titleStyle?: object;
  subtitle?: string;
  subtitleStyle?: object;
  message: string;
  messageStyle?: object;
  image?: string;
  imageStyle?: object;
  buttonsConfig?: Array<{
    translation: string;
    text: string;
    action?: boolean;
    color?: string;
  }>;
  dynamicComponent?: any;
  dynamicComponentData?: any;
  textAlign?: string;
  closeButtonTop?: boolean;
  closeButtonTopStyle?: object;
  fullscreen?: boolean;
  customHeightPercentatge?: number;
  links: string[] | undefined;
  initForm?: any
}

/*
  This class is used in the domain layer for the MarketingDialog to
  extend this class.
  But it is also used for the params
  to open a dialog inside the presentation layer.
*/
export class Dialog {
  /*** Dialog design ***/

  /* If true, dialog height will be 100dvh */
  public readonly fullscreen?: boolean;
  /* Number specifying the % of the total screen from 0 to 100 the dialog will fit.
  fullscreen must be false or undefined */
  public readonly customHeightPercentatge?: number;
  /* If true, a close button will be shown at the top */
  public readonly closeButtonTop?: boolean;
  /* CSS style aplied to close cross button */
  public readonly closeButtonTopStyle?: object;
  /* Array with the config to create buttons at the bottom of the dialog  */
  public readonly buttonsConfig?: Array<{
    /* Translated button text from the backend  */
    translation: string;
    /* Not translated button text from the backend  */
    text: string;
    /* The backend can specify a string that the dialog returns
    when it is closed. It is done in order to identify an action 
    that should be done when the dialog is closed */
    action?: boolean;
    /* Same as action but accepting more custom values instead just true/false*/
    action_string?: string;
    /* Color of the button */
    color?: string;
    ui_color?: "primary" | "secondary" | "gray" | "black" | "white" | "info" | "warning" | "error" | "success";
    /* Color of the button */
    class?: string;
    /* Optional param send from backend to open a external link */
    redirectUrl?: string;
    links?: string[];
  }>;

  /*** Content of the dialog ***/

  /* Required: Title of the dialog */
  public readonly title: string;
  /* CSS style aplied to title */
  public readonly titleStyle?: object;
  /* Text below title */
  public readonly subtitle?: string;
  /* CSS style aplied to susbtitle */
  public readonly subtitleStyle?: object;
  /* An image to be displayed between the title and the message */
  public readonly image?: string;
  /* CSS style aplied to image */
  public readonly imageStyle?: object;
  /* Required: Dialog message */
  public readonly message: string;
  /* CSS style aplied to the message */
  public readonly messageStyle?: object;
  /* Alignment of all the text inside the dialog */
  public readonly textAlign?: string;
  /* Type of the modal to display UI colors */
  public readonly type?: "error" | "info" | "warning" | "success";
  public readonly links?: string[];

  /*** The properties below can only be inicicalized by the app ***/

  /* If you specify an App component it will be rendered inside the dialog */
  public readonly dynamicComponent?: any;
  /* The data passed to the constructor of component rendered inside the dialog */
  public readonly dynamicComponentData?: any;
  public initForm?: any

  constructor(params: DialogParams) {
    this.title = params.title;
    this.titleStyle = params.titleStyle;
    this.subtitle = params.subtitle;
    this.subtitleStyle = params.subtitleStyle;
    this.message = params.message;
    this.messageStyle = params.messageStyle;
    this.image = params.image;
    this.buttonsConfig = params.buttonsConfig;
    this.dynamicComponent = params.dynamicComponent;
    this.dynamicComponentData = params.dynamicComponentData;
    this.textAlign = params.textAlign;
    this.closeButtonTop = params.closeButtonTop;
    this.links = params.links;
    this.initForm = params.initForm;
  }
}
